<form class="dynamicform" [formGroup]="form" >
    <ng-container *ngFor="let field of config;" dynamicField [config]="field" [group]="form">
    </ng-container>
</form>
